import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
    defaultPageSize,
    pageSizeOptions,
    showSizeChanger,
    AsumsiIcon,
    IColumnProps, Table, Tooltip
} from 'asumsi-components';
import moment from "moment";

export default function (props: any) {
    const { dataSource, metaData, onTableChange, loading } = props;

    const columns: IColumnProps[] = [
        {
            dataIndex: 'title',
            key: 'title',
            title: 'Title',
            sorter: true,
        },
        {
            dataIndex: 'url',
            key: 'url',
            title: 'Url',
            sorter: true,
            render: (text: string) => <a className="content-url" href={text} target="blank">{text}</a>
        },
        {
            dataIndex: 'topic',
            key: 'topic',
            title: 'topic',
            sorter: true,
            render: (text: any) => text ? text.name : null
        },
        {
            dataIndex: 'createdAt',
            key: 'createdAt',
            title: 'Created Date',
            columnWidht: "10%",
            render: (text: string) => moment(text).format('DD MMM YYYY HH:MM')
        },
        {
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            title: 'Updated Date',
            columnWidht: "10%",
            render: (text: string) => moment(text).format('DD MMM YYYY HH:MM')
        },
        {
            dataIndex: 'isActive',
            key: 'isActive',
            title: 'Status',
            columnWidht: "8%",
            render: (text: string, record: any) => record.isActive == true ? 'Active' : 'Inactive'
        },
        {
            dataIndex: 'action',
            key: 'action',
            render: (text: string, record: any) => {
                return (
                    <div className="bt-table__action">
                        <Tooltip text="edit">
                            <Link to={`/article/videos/form/${record.id}`} style={{ marginRight: "8px" }}>
                                <AsumsiIcon icon="annotation" />
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
            columnWidht: "8%",
            title: 'Action',
        },
    ];

    return (
        <Fragment>
            <Table columns={columns}
                dataSource={dataSource}
                className="asumsi-table"
                loading={loading}
                pagination={{
                    currentPage: metaData ? metaData.page : 1,
                    defaultPageSize: metaData ? metaData.limit : defaultPageSize,
                    pageSizeOptions,
                    showSizeChanger,
                    total: metaData ? metaData.totalRecords : 0,
                }}
                rowKey="id"
                onChange={onTableChange}
                upperCaseTitle={true}
            ></Table>
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/videos/libraries/table.tsx